import { IErrorResponseType } from "../../constants/commonTypes";
import { SuccessState } from "../reducers/successReducer";

export const SUBMIT_ARC_APPROVE = "SUBMIT_ARC_APPROVE"
export const SUBMIT_ARC_APPROVE_REQUEST = "SUBMIT_ARC_APPROVE_REQUEST"
export const SUBMIT_ARC_APPROVE_FAILURE = "SUBMIT_ARC_APPROVE_FAILURE"
export const SUBMIT_ARC_APPROVE_SUCCESS = "SUBMIT_ARC_APPROVE_SUCCESS"


export interface SubmitARCApproveAction {
  type: typeof SUBMIT_ARC_APPROVE;
}

export interface SubmitARCApproveRequestAction {
  type: typeof SUBMIT_ARC_APPROVE_REQUEST;
}

export interface SubmitARCApproveSuccessAction {
  type: typeof SUBMIT_ARC_APPROVE_SUCCESS;
  response: SuccessState;
}

export interface SubmitARCApproveFailureAction {
  type: typeof SUBMIT_ARC_APPROVE_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export type SuccessActions =
  | SubmitARCApproveAction
  | SubmitARCApproveRequestAction
  | SubmitARCApproveSuccessAction
  | SubmitARCApproveFailureAction;